import api from "./api";

export type QuizTheme = {
  id: string;
  name: string;
  title: string;
  created_at: string;
  updated_at: string;
  _count?: { quizzes: number };
};

export async function getQuizThemes() {
  const { data } = await api.get<QuizTheme[]>("/quiz-themes");
  return data;
}

export async function getQuizTheme(themeId: string) {
  const { data } = await api.get<QuizTheme>(`/quiz-themes/${themeId}`);
  return data;
}

export async function createQuizTheme(payload: { name: string; title: string }) {
  const { data } = await api.post<QuizTheme>("/quiz-themes", payload);
  return data;
}

export async function updateQuizTheme(themeId: string, payload: { name?: string; title?: string }) {
  const { data } = await api.patch<QuizTheme>(`/quiz-themes/${themeId}`, payload);
  return data;
}

export async function deleteQuizTheme(themeId: string) {
  const { data } = await api.delete(`/quiz-themes/${themeId}`);
  return data;
}

export type ThemeQuiz = {
  id: string;
  title: string;
  category: string | null;
  is_active: boolean;
  theme_order: number | null;
};

export async function getThemeQuizzes(themeId: string) {
  const { data } = await api.get<ThemeQuiz[]>(`/quiz-themes/${themeId}/quizzes`);
  return data;
}

export async function setThemeQuizOrder(themeId: string, quizIds: string[]) {
  const { data } = await api.put(`/quiz-themes/${themeId}/quizzes/order`, { quiz_ids: quizIds });
  return data;
}
